const DepartmentEnum = {
  RM: 1,
  KAM: 4,
  BD: 5,
  DQ: 6,
  IT: 9,
  BI: 10,
  Finance: 11,
  Marketing: 12,
  HR: 13,
};

export default DepartmentEnum;
